import { observer } from 'mobx-react-lite';
import React, { Fragment, useContext } from 'react';
import { Button, Label, Table } from 'semantic-ui-react';

import { formatListDisp2, PROCESS_STATE } from '../../../app/common/util/util';
import { IDepositSalesTicketPrint } from '../../../app/models/depositSalesTicket';
import { RootStoreContext } from '../../../app/stores/rootStore';

const PrintList: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { depositSalesTicketPrints } = rootStore.depositSalesTicketStore;

  return (
    <Fragment>
      <Label size='large'>※PDFファイルは、発券後１ヶ月で削除されます。</Label>
      <Table celled compact striped selectable size='small'>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell>発券日時</Table.HeaderCell>
            <Table.HeaderCell>発券担当者名</Table.HeaderCell>
            <Table.HeaderCell>チケットNo</Table.HeaderCell>
            <Table.HeaderCell>枚数</Table.HeaderCell>
            <Table.HeaderCell width={2}>ステータス</Table.HeaderCell>
            <Table.HeaderCell width={2}>PDFファイル</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {depositSalesTicketPrints.map(
            (depositSalesTicketPrint: IDepositSalesTicketPrint) => (
              <Table.Row
                key={depositSalesTicketPrint.depositSalesTicketPrintId}
              >
                <Table.Cell>
                  {formatListDisp2(
                    new Date(depositSalesTicketPrint.ticketReserveTime)
                  )}
                </Table.Cell>
                <Table.Cell>
                  {depositSalesTicketPrint.ticketReserveClerkName}
                </Table.Cell>
                <Table.Cell>{depositSalesTicketPrint.ticketNo}</Table.Cell>
                <Table.Cell>
                  {depositSalesTicketPrint.count.toLocaleString()}
                </Table.Cell>
                <Table.Cell>
                  {depositSalesTicketPrint.ticketPrintStatusName}
                </Table.Cell>
                <Table.Cell singleLine>
                  <a
                    href={depositSalesTicketPrint.ticketFileUri}
                    rel='noreferrer noopener'
                    target='_blank'
                    download
                  >
                    <Button
                      content='ダウンロード'
                      color='blue'
                      compact
                      disabled={
                        depositSalesTicketPrint.ticketPrintStatusEnum !==
                        PROCESS_STATE.Done
                      }
                    />
                  </a>
                </Table.Cell>
              </Table.Row>
            )
          )}
        </Table.Body>
      </Table>
    </Fragment>
  );
};

export default observer(PrintList);
